import { render } from "./RiwayatJadwalPiket.vue?vue&type=template&id=a3561390"
import script from "./RiwayatJadwalPiket.vue?vue&type=script&lang=js"
export * from "./RiwayatJadwalPiket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__